import React, { ReactNode, useContext } from 'react'

interface SearchReportOrdersContextInterface {
  order: string
  setOrder: (order: string) => void
  item: string
  setItem: (item: string) => void
  processOrder: string
  setProcessOrder: (processOrder: string) => void
  templateTest: any[] | undefined
  setTemplateTest: (value: any[] | undefined) => void
}

export const SearchReportOrdersContext =
  React.createContext<SearchReportOrdersContextInterface>(
    {} as SearchReportOrdersContextInterface
  )

interface SearchReportOrdersProviderProps {
  children: ReactNode
}

const SearchReportOrdersProvider = ({
  children,
}: SearchReportOrdersProviderProps) => {
  const [order, setOrder] = React.useState<string>('')
  const [item, setItem] = React.useState<string>('')
  const [processOrder, setProcessOrder] = React.useState<string>('')
  const [templateTest, setTemplateTest] = React.useState<any[] | undefined>(
    undefined
  )

  return (
    <SearchReportOrdersContext.Provider
      value={{
        order,
        setOrder,
        item,
        setItem,
        processOrder,
        setProcessOrder,
        templateTest,
        setTemplateTest,
      }}
    >
      {children}
    </SearchReportOrdersContext.Provider>
  )
}

function useSearchReportOrders(): SearchReportOrdersContextInterface {
  return useContext(SearchReportOrdersContext)
}

export { SearchReportOrdersProvider, useSearchReportOrders }
